import { BMText } from "@traveloka/district-bloom";
import { Pressable } from "react-native";
import { BMDropdownField, BMDropdownOptionsValue } from "../../../components";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../utils";

type Props = {
  value: string | null;
  options: {
    data: BMDropdownOptionsValue[];
    loading: boolean;
    error: string | null;
    refetch: () => void;
  };
  error: string | undefined;
  onChange: (value: string | null) => void;
  onBlur: () => void;
  onClickAdd: (value: string) => void;
};

export default function DivisionsField({
  value,
  error,
  options,
  onChange,
  onBlur,
  onClickAdd,
}: Props) {
  const { data, loading, error: optionsError, refetch } = options;
  const { CorporateManagementEmployeeList: cr } = useMobileContentResource();
  return (
    <BMDropdownField
      label={cr.divisionColumn}
      value={value}
      variant="RADIO"
      onBlur={onBlur}
      onChange={onChange}
      error={error}
      zIndex={11}
      option={{
        items: data || [],
        isLoading: loading,
        isError: !!optionsError,
        onClickRetry: refetch,
      }}
      optionsSection={{
        title: cr.divisionColumn,
      }}
      returnKeyType="done"
      searchable={{
        placeholder: cr.divisionInputPlaceholder,
        noResultCaption: cr.divisionInputNotFoundSubtitle,
        NoResultFooterComponent: ({ query }) => {
          const ctaContent = formatMessage(cr.divisionInputNotFoundAddButton, {
            division: query,
          });

          return (
            <>
              <Pressable
                onPress={() => {
                  // This on click only add the new division to the list locally (has not call API yet)
                  // The division will be created when the user applied the division filter
                  onClickAdd?.(query);

                  // Select the newly added division
                  onChange(query);
                }}
              >
                <BMText
                  variant="uiNormal"
                  ink="BMStyleTextInkAction"
                  numberOfLines={2}
                  ellipsizeMode="tail"
                >
                  {ctaContent}
                </BMText>
              </Pressable>
            </>
          );
        },
      }}
    />
  );
}
